// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
enum TemperatureSensorEnum {
    Thermocouple = 'Thermocouple',
    Opi = 'Opi',
    PowerCast = 'PowerCast',
    BinSense = 'BinSense',
}
export default TemperatureSensorEnum;
